import BaseHttpService from "JS/services/BaseHttpService";
import { IBaseHttpService } from "JS/types/Http";
import { IPDPAddToCartResponse } from './ProductService';
import { SubscriptionTabResource, UpdateSubscriptionRequest } from 'JS/types/subscription';

export interface ISubscriptionService {
	getActiveSubscriptions(): Promise<SubscriptionTabResource>;
	getFrequencyOptions(): Promise<number[]>;
	updateSubscription(request: UpdateSubscriptionRequest): Promise<boolean>;
	cancelSubscription(subscriptionID: number): Promise<boolean>;
	orderSubscriptionProduct(subscriptionId: number): Promise<IPDPAddToCartResponse>;
}

const BASE_URL = "/account/subscriptions";
export default class SubscriptionService implements ISubscriptionService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService()) {}

	getActiveSubscriptions(): Promise<SubscriptionTabResource> {
		return this._httpService.get<SubscriptionTabResource>(`${BASE_URL}/get-active`);
	}

	getFrequencyOptions(): Promise<number[]> {
		return this._httpService.get<number[]>(`${BASE_URL}/get-frequency-options`);
	}

	updateSubscription(request: UpdateSubscriptionRequest): Promise<boolean> {
		return this._httpService.post<boolean>(`${BASE_URL}/update`, request);
	}

	cancelSubscription(subscriptionID: number): Promise<boolean> {
		return this._httpService.post<boolean>(`${BASE_URL}/cancel`, { subscriptionID: subscriptionID });
	}

	orderSubscriptionProduct(subscriptionId: number, qty: number | null = null): Promise<IPDPAddToCartResponse> {
		return this._httpService.post<IPDPAddToCartResponse>(`${BASE_URL}/buy-it-now`, { subscriptionId: subscriptionId, qty });
	}

}